"use client";

import Image from "next/image";
import classNames from "classnames";
import { GFIIconMap } from "@/constants/gluten-free";
import { GlutenFreeIdentityItem } from "@/components/atoms/GlutenFreeIdentityItem";
import { InquireText } from "@/components/atoms/GlutenFreeInquireText";

import { Inter } from "next/font/google";
import { trackItemTapped } from "@/utils/mixpanel";
import { MixpanelValues } from "@/constants/mixpanel";

const inter = Inter({ subsets: ["latin"] });

const ICON_SIZE = 28;

export const GlutenFreeIdentity = ({ data, isMobile, lean }) => {
    if (!data) {
        return null;
    }

    if (lean) {
        const title =
            data.header.title === "In vetting process"
                ? "Gluten-free options"
                : data.header.title;
        return (
            <div
                // id="generic-modal-trigger-top-place-identity"
                onClick={() => {
                    trackItemTapped(MixpanelValues.ItemTapped.SAFETY_RATING);
                    const searchParams = new URLSearchParams(window.location.search);
                    searchParams.set("slider", "true");
                    window.history.pushState({}, "", `?${searchParams.toString()}`);
                }}
                className={classNames({
                    "flex items-center gap-1": true,
                    "py-1 pb-3 md:py-2": true,
                    "box-border md:rounded-2xl": true,
                })}>
                <Image
                    src={GFIIconMap[data.header.icon]}
                    width={16}
                    height={16}
                    alt="Gluten Free Icon"
                />
                <p
                    className={classNames(inter.className, {
                        "text-[13px] md:text-[18px] flex flex-col md:inline-table": true,
                        "md:items-center md:flex-row md:h-7": true,
                    })}>
                    <b>{title}</b>
                </p>
            </div>
        );
    }

    return (
        <div
            className={classNames({
                "px-2 py-1 md:px-4 md:py-2": true,
                "box-border md:rounded-2xl p-4 bg-white": true,
                "last-of-type:border-none border-b md:border border-zinc-200": true,
            })}>
            <div
                className={classNames(inter.className, {
                    "py-2 px-0.5": true,
                    "flex items-center md:flex-col md:items-start gap-3": true,
                    "md:text-xl text-sky-950": true,
                })}>
                <div className="pt-1 md:pt-0">
                    <Image
                        src={GFIIconMap[data.header.icon]}
                        width={ICON_SIZE}
                        height={ICON_SIZE}
                        alt="Gluten Free Icon"
                    />
                </div>
                <p
                    className={classNames({
                        "text-[13px] flex flex-col md:inline-table": true,
                        "md:items-center md:flex-row md:text-[20px] md:h-7": true,
                    })}>
                    <b className="mr-2">{data.header.title}</b>
                    {data.header.subtitle}
                </p>
            </div>
            {data.elements.items.length > 0 ? (
                <div
                    className={classNames({
                        "flex flex-col md:flex-row": true,
                        "gap-2": true,
                        "flex-wrap": true,
                        "pb-3": true,
                    })}>
                    {data.elements.items.map((item, index) => {
                        return (
                            <GlutenFreeIdentityItem
                                key={index}
                                item={item}
                                isMobile={isMobile}
                            />
                        );
                    })}
                </div>
            ) : null}
            <div className="px-3 pb-2 md:pt-4 text-[11px] md:border-t md:border-zinc-200">
                <InquireText text={data.footer.text} />
            </div>
        </div>
    );
};
